import axiosInstance from './../providers/Axios';
import { getBannerBank } from '../config/paths';

/**
 * @name callGetBannerBank
 * @returns {Promise<{
            "links": {
                "desktop": "http...",
                "mobile": "http..."
            },
            "images": {
                "desktop": "http...",
                "mobile": "http..."
            }
}>}
 *
 */
export const callGetBannerBank = async () => {
  return axiosInstance({
    url: getBannerBank,
    method: 'get',
  });
};
